/* eslint-disable max-len */
import React, { useEffect, useState, Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty } from 'lodash';
import { round } from 'mathjs';

import '../../scss/public.scss';
import './scss/index.scss';
import Color from '@tool/color';
import SubTitle from '../../component/sub-title';
import moFee, {
  changeType,
} from './store/index';
import IncomeLeft from '../../component/income-left';
import Income from '../../component/income';
import NewIncome from '../../component/new-income';
import CommonTable from '../../component/common-table';
import Empty from '@/component/empty';
import { exportExcelFile, newRate } from '@tool/index';
import moMenu from '../../store/menu';

interface IProps {}
interface IState {}

const FeeRate = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const {
    type, empty, tableTitle, tableList, overview,
    developX, developY, saleX, saleY, adminX, adminY,
  } = moFee;

  const exporttable = () => {
    const head:any = [
      ['年份', '研发类薪酬/研发费用', '销售类薪酬/销售费用', '管理类薪酬/管理费用'],
    ];
    const list:any = [...head, ...tableList];
    const merge:any = [];
    exportExcelFile(list, merge, '费用中的薪酬占比');
  };

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section id="effect10" className="income-fee-rate_10 box-111">
      <SubTitle title="费用中的薪酬占比" subtitle={moMenu.industryName} active={type}
        bg={Color.primaryColor(0.1)} color={Color.primary}
        tabChange={(val: string) => changeType(val)}
        contentList={['研发类薪酬/研发费用的计算方式：将该行业下所有样本公司的研发类员工的薪酬成本加总，然后除以所有样本公司的研发费用加总。销售类薪酬/销售费用、管理类薪酬/管理费用的计算方式与研发类薪酬/研发费用的计算方式相同。']} />
      {type === 'chart' ? (
        <>
          {!empty ? (
            <section className="content-1011 content-1013">
              <section className="content-0011">
                <section className="fee-1011">
                  <p className={'line-1019 line-1011'}
                    style={{ borderBottom: 'none' }}>
                    <strong>研发类薪酬/研发费用</strong>
                  </p>
                  <Income height={300} xData={developX} yData={developY}
                    bgColor={Color.d9Color(0.05)} name="研发类薪酬/研发费用" />
                </section>
                <section className="fee-1011">
                  <p className={'line-1011'} style={{ borderBottom: 'none' }}>
                    <strong>销售类薪酬/销售费用</strong>
                  </p>
                  <NewIncome height={300} xData={saleX} yData={saleY}
                    bgColor={Color.secondaryColor(0.05)} name="销售类薪酬/销售费用" />
                </section>
                <section className="fee-1011">
                  <p className={'line-1011'} style={{ borderBottom: 'none' }}>
                    <strong>管理类薪酬/管理费用</strong>
                  </p>
                  <NewIncome height={300} xData={adminX} yData={adminY}
                    bgColor={Color.twoColor(0.05)} name="管理类薪酬/管理费用" />
                </section>
              </section>
              <section className="chart-detail_11 industry-detail_11"
                style={{ width: '100%', marginTop: '26px', height: 'auto' }}>
                {overview.map((item: any, index: number) => (
                  <section key={index} className="item">
                    <span className="circle-111"><b /></span>
                    <p className="line-111">
                      {item.map((child: any, idx: number) => (
                        <Fragment key={idx}>
                          {child.mark === 'number' ? (
                            <span className="blue-11">{child.value}</span>
                          ) : null}
                          {child.mark === 'change_ratio' ? (
                            <>
                              {child.value >= 0 ? (
                                <span className="red-11">{newRate(child.value)}</span>
                              ) : (
                                <span className="green-11">{newRate(child.value)}</span>
                              )}
                            </>
                          ) : null}
                          {(child.mark !== 'number' && child.mark !== 'change_ratio') ? (
                            <span className="span-11">{child.value}</span>
                          ) : null}
                        </Fragment>
                      ))}
                    </p>
                  </section>
                ))}
              </section>
            </section>
          ) : (<Empty />)}
        </>
      ) : (
        <section className="section-151">
          {type === 'table' && <section onClick={exporttable} className='export-table'>导出excel</section>}
          {!empty ? (
            <CommonTable titleList={tableTitle} list={tableList} />
          ) : (<Empty />)}
        </section>
      )}
    </section>
  );
};

export default observer(FeeRate);
